// components/Modal.tsx
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

export const Modal = ({ isOpen, onClose, title, children }: ModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white border border-slate-200 rounded-2xl shadow-2xl max-w-md w-full p-6 relative text-slate-800 space-y-4"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.95 }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-slate-400 hover:text-red-500 transition"
            >
              <X size={20} />
            </button>
            <h2 className="text-xl font-bold text-indigo-600">{title}</h2>
            <div className="text-sm text-slate-600">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
